<template>
  <div>
    <span v-if="stackTime" class="ovd-date-stack">
      <span class="ovd-date-line">{{ getDate(orderData) | moment('YYYY-MM-DD') }}</span>
      <span class="ovd-time-line">{{ getDate(orderData) | moment('hh:mm A') }}</span>
    </span>
    <span v-else>{{ getDate(orderData) | moment('YYYY-MM-DD hh:mm A') }}</span>
    <div class="hover-content">
      <div class="popover-arrow">&nbsp;</div>
      <div class="d-flex my-2">
        <div style="width: 40%">{{ $t('customer.orderDate') }}</div>
        <div class="text-right">{{ getOrderDate(orderData) | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.pending_answer_at"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.pending_answer_at"
        class="d-flex my-2"
      >
        <div style="width: 40%">{{ $t('viewOrderDates.pendingAnswerDateLabel') }}</div>
        <div class="text-right">{{ orderData.pending_answer_at | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.process_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.process_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">{{ $t('viewOrderDates.processDateLabel') }}</div>
        <div class="text-right">{{ orderData.process_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.cancel_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.cancel_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">{{ $t('viewOrderDates.cancelDateLabel') }}</div>
        <div class="text-right">{{ orderData.cancel_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.confirm_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.confirm_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">{{ $t('viewOrderDates.approveDateLabel') }}</div>
        <div class="text-right">{{ orderData.confirm_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.refund_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.refund_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">{{ $t('viewOrderDates.refundDateLabel') }}</div>
        <div class="text-right">{{ orderData.refund_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.purchase_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.purchase_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">{{ $t('columns.purchaseDate') }}</div>
        <div class="text-right">{{ orderData.purchase_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.warehouse_deliver_date || orderData.pending_to_shipment"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.warehouse_deliver_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">{{ $t('columns.warehouseDate') }}</div>
        <div class="text-right">{{ orderData.warehouse_deliver_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.pending_to_shipment_at"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.pending_to_shipment_at"
        class="d-flex my-2"
      >
        <div style="width: 40%">{{ $t('viewOrderDates.pendingShipmentDateLabel') }}</div>
        <div class="text-right">{{ orderData.pending_to_shipment_at | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.int_shipment_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.int_shipment_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">{{ $t('viewOrderDates.shipmentDateLabel') }}</div>
        <div class="text-right">{{ orderData.int_shipment_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.pending_to_branch_at"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.pending_to_branch_at"
        class="d-flex my-2"
      >
        <div style="width: 40%">
          <div>{{ $t('adminDashboard.pendingToBranchLabel') }}</div>
        </div>
        <div class="text-right">{{ orderData.pending_to_branch_at | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.branch_delivery_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.branch_delivery_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">{{ $t('orders.deliveredToErbilOption') }}</div>
        <div class="text-right">{{ orderData.branch_delivery_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

      <div
        v-if="orderData.deliver_date"
        style="border-bottom: 1px dashed #ddd"
      />

      <div
        v-if="orderData.deliver_date"
        class="d-flex my-2"
      >
        <div style="width: 40%">{{ $t('viewOrderDates.deliveredDateLabel') }}</div>
        <div class="text-right">{{ orderData.deliver_date | moment('YYYY-MM-DD hh:mm A') }}</div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    orderData: {
      type: Object,
      required: true
    },
    // Opt-in only: splits the visible date onto its own line and the time onto the
    // next line (used by allOrder.vue's redesigned Date & Payment column). Defaults to
    // false so every other page that uses this component keeps the original single-line
    // "YYYY-MM-DD hh:mm A" display.
    stackTime: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    getOrderDate(order) {
      return order.order_date ? order.order_date : order.created_at
    },

    getDate(order) {
      if (order.status_id_fk === 1) {
        return order.order_date ? order.order_date : order.created_at
      }

      if (order.status_id_fk === 2) return order.process_date

      if (order.status_id_fk === 3 || order.is_canceled === '1') return order.cancel_date

      if (order.status_id_fk === 4) return order.confirm_date

      if (order.status_id_fk === 5) return order.refund_date

      if (order.status_id_fk === 6) return order.purchase_date

      if (order.status_id_fk === 7 || order.status_id_fk === 15) return order.warehouse_deliver_date

      if (order.status_id_fk === 8) return order.int_shipment_date

      if (order.status_id_fk === 9) return order.branch_delivery_date

      if (order.status_id_fk === 10) return order.deliver_date

      if (order.status_id_fk === 12) return order.order_date

      if (order.status_id_fk === 13) return order.pending_to_branch_at

      if (order.status_id_fk === 14) return order.pending_answer_at
    }
  }
}
</script>

<style>
/* Only rendered when stackTime is true (see prop above), so this never affects the
   ~20 other pages that use this component without the prop. */
.ovd-date-stack {
  display: inline-flex;
  flex-direction: column;
}
.ovd-time-line {
  font-size: 12px;
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/components/viewOrderDates.vue